import * as React from 'react';

import { FormParserContext } from 'src/contexts/form.context';
import { InputContext } from 'src/contexts/input.context';
import { GroupsAutoComplete as GroupsAutoCompleteComponent } from 'src/components/InputRenderers';
import { AutoCompleteDomains } from 'src/models';
import { ifTrue } from 'src/tools/logic.tools';

interface Props {
  domain?: AutoCompleteDomains.TRADE_GROUP | AutoCompleteDomains.MAIN_GROUP;
}

export function GroupsAutoComplete({ domain }: Props) {
  const {
    value,
    script,
    onChange,
    writeData = [],
    actions,
    error,
    isDisabled,
    period,
  } = React.useContext(FormParserContext);

  const [setGroupName] = writeData;

  function handleOnChange(group: string) {
    onChange(group);

    if (setGroupName) setGroupName(group);
  }

  return (
    <InputContext.Provider
      value={{
        classNames: { container: 'w-100p', input: ifTrue(error, 'with-error') },
        value: value ?? undefined,
        onChange: handleOnChange,
        isDisabled: script.isDisabled || isDisabled,
        isAutoFocus: script.autofocus,
        placeholder: script.placeholder,
        actions: {
          onChangeInput: setGroupName,
          onAddGroup: actions?.addGroup,
        },
      }}
    >
      <GroupsAutoCompleteComponent domain={domain} period={period} />
    </InputContext.Provider>
  );
}
